import type { ReactNode } from 'react';
import type { IconType } from 'react-icons';
import type { MascotName } from '../illustrations';
import { cx } from './cx';
import { IconMedallion } from './IconMedallion';
import { Mascot } from './Mascot';

export interface EmptyStateProps {
  title: string;
  body?: ReactNode;
  /** A Lucide icon in a peach medallion. Ignored when `mascot` is set. */
  icon?: IconType;
  /** A small decorative giraffe in place of the icon. */
  mascot?: MascotName;
  /** Usually a Button. */
  action?: ReactNode;
  /** h1 only where the state IS the page (the quiz's Result Error). */
  headingLevel?: 'h1' | 'h2' | 'h3' | 'h4';
  className?: string;
}

/** Nonjudgmental empty state: visual, title, one line of body, optional action. */
export function EmptyState({
  title,
  body,
  icon,
  mascot,
  action,
  headingLevel: Heading = 'h3',
  className,
}: EmptyStateProps) {
  return (
    <div className={cx('ee-empty', className)}>
      {mascot ? (
        <Mascot name={mascot} className="ee-empty__mascot" />
      ) : icon ? (
        <IconMedallion icon={icon} size="lg" />
      ) : null}
      <Heading className="ee-empty__title">{title}</Heading>
      {body ? <p className="ee-empty__body">{body}</p> : null}
      {action ? <div className="ee-empty__action">{action}</div> : null}
    </div>
  );
}
